import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import LoadingSpinner from '../../components/LoadingSpinner'
import { Api, Endpoint } from '../../api'
import { buildMenuSearch } from '../../helpers/navigation'
import MenuIntroCard from '../../components/MenuIntroCard'
import menuStyles from '../../components/Wrappers/MenuWrapper.module.scss'
import styles from './CombinedLanding.module.scss'

function buildMenuCards(vendors = []) {
	return vendors.flatMap((vendor) =>
		vendor.menus.map((menu) => ({
			key: `${vendor.restaurant._id}-${menu._id}`,
			restaurantId: vendor.restaurant._id,
			menu,
			title: `${vendor.restaurant.name} - ${menu.name}`,
			coverImage: menu.cover || vendor.restaurant.logo,
		}))
	)
}

export default function CombinedLanding() {
	const { dmaId } = useParams()
	const history = useHistory()
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)
	const [data, setData] = useState(null)

	useEffect(() => {
		const load = async () => {
			setLoading(true)
			const response = await Api.call(Endpoint.DMA.landing(dmaId))
			setLoading(false)
			if (response?.statusCode === 200 && response?.message) {
				setData(response.message)
				setError(null)
				return
			}
			setError(response?.message || 'Unable to load menus')
		}
		load()
	}, [dmaId])

	const menuCards = useMemo(() => buildMenuCards(data?.vendors), [data?.vendors])

	const openMenu = (restaurantId, menu) => {
		history.push({
			pathname: `/menu/${restaurantId?.toString()}`,
			search: buildMenuSearch({ menuId: menu?._id?.toString(), dmaId }),
		})
	}

	if (loading) {
		return (
			<div className={styles.emptyState}>
				<LoadingSpinner />
			</div>
		)
	}

	if (error) {
		return (
			<div className={styles.emptyState}>
				<h3>{error}</h3>
			</div>
		)
	}

	const title = data?.dma?.company_name || 'Menus'

	return (
		<div className={menuStyles.introPage}>
			<div className={menuStyles.introHeader}>
				<h2 className={styles.hubHeader}>{title}</h2>
				<h5>Choose a menu:</h5>
			</div>

			{!menuCards.length ? (
				<div className={styles.emptyState}>
					<p>No published menus are available right now.</p>
				</div>
			) : (
				<div className={menuStyles.multipleMenus}>
					{menuCards.map((card) => (
						<MenuIntroCard
							key={card.key}
							menu={card.menu}
							title={card.title}
							coverImage={card.coverImage}
							onSelect={() => openMenu(card.restaurantId, card.menu)}
						/>
					))}
				</div>
			)}
		</div>
	)
}
